module.exports = __webpack_public_path__ + "img/zhifubao.3358f2e6.svg";